// extracted by mini-css-extract-plugin
export default {"wrapper":"settings_wrapper__QEpXm","fieldContainer":"settings_fieldContainer__RNRor","formBox":"settings_formBox__zFmP4"};